import { AUDIT_LIST_QUERY_KEYS } from 'app/modules/auditService/queries/keys';

import { get } from 'app/shared/utils/fetchr';
import { useInfiniteQuery } from '@tanstack/react-query';
import {
  AuditTrailAssetType,
  AuditServiceEntry,
} from 'app/modules/auditService/types';

export interface AuditServiceResponse {
  rawAssetId: string;
  auditLogs: AuditServiceEntry[];
  rawAssetType: string;
}

const listAuditTrail = (
  assetType: AuditTrailAssetType,
  assetId: string,
  offset: number = 1,
  limit: number = 100,
  excludeNoisyEvents: boolean = false,
): Promise<AuditServiceResponse> =>
  get(
    `/v1/audit-service/${assetType}/${assetId}/list?offset=${offset}&limit=${limit}${
      excludeNoisyEvents ? '&exclude_noisy_events=true' : ''
    }`,
  );

export const useAuditServiceList = (
  assetType: AuditTrailAssetType,
  assetId: string,
  excludeNoisyEvents: boolean = false,
) => {
  return useInfiniteQuery({
    queryKey: AUDIT_LIST_QUERY_KEYS.list(
      assetType,
      assetId,
      excludeNoisyEvents,
    ),
    queryFn: ({ pageParam: offset }) =>
      listAuditTrail(assetType, assetId, offset, 100, excludeNoisyEvents),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.auditLogs?.length === 0) {
        return undefined;
      }
      return lastPageParam + 1;
    },
    meta: { errorMessage: 'Failed to get audit history.' },
    enabled: assetId !== '',
  });
};
